import BottomBar from './BottomBar';
import { connect } from 'react-redux';

const mapStateToProps = ({ siteInfo }) => ({ bottomText: siteInfo.bottomText });

export default connect(mapStateToProps)(BottomBar);
